module.exports = __webpack_public_path__ + "static/media/ce-marking-logo.a4d59ac8.svg";